// extracted by mini-css-extract-plugin
export default {"OuterContainer":"xOIeq27p","ExitButton":"FEgZTznc","CardButton":"JQTMdvqa","ButtonAlignment":"hsch63bN"};